import type { ReactElement } from "react";

import { styled } from "simplydo/react/styled";

import { StyledTabPane, tabPaneClassName } from "./Tab.styles";
import type { TabPaneProps } from "./Tab.types";

const TabPaneComponent = ({
  active = true,
  children,
  className,
  style,
  loading,
  ...rest
}: TabPaneProps): ReactElement => {
  return (
    <StyledTabPane
      className={tabPaneClassName(className, loading)}
      style={style}
      $active={active}
      {...rest}
    >
      {children}
    </StyledTabPane>
  );
};

export const TabPane = styled(TabPaneComponent)``;
